var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};

// server/services/ewelink/lib/utils/constants.js
var require_constants = __commonJS({
  "server/services/ewelink/lib/utils/constants.js"(exports, module) {
    var EWELINK_EMAIL_KEY = "EWELINK_EMAIL";
    var EWELINK_PASSWORD_KEY = "EWELINK_PASSWORD";
    var EWELINK_REGION_KEY = "EWELINK_REGION";
    var EWELINK_REGIONS = {
      EU: "eu",
      US: "us"
    };
    var DEVICE_SERVICE_ID = "ewelink";
    var DEVICE_EXTERNAL_ID_BASE = "ewelink";
    var DEVICE_IP_ADDRESS = "IP_ADDRESS";
    var DEVICE_FIRMWARE = "FIRMWARE";
    var DEVICE_ONLINE = "ONLINE";
    module.exports = {
      EWELINK_EMAIL_KEY,
      EWELINK_PASSWORD_KEY,
      EWELINK_REGION_KEY,
      EWELINK_REGIONS,
      DEVICE_SERVICE_ID,
      DEVICE_EXTERNAL_ID_BASE,
      DEVICE_IP_ADDRESS,
      DEVICE_FIRMWARE,
      DEVICE_ONLINE
    };
  }
});
const __cjsModule = require_constants();
export default __cjsModule;
export const EWELINK_EMAIL_KEY = __cjsModule.EWELINK_EMAIL_KEY;
export const EWELINK_PASSWORD_KEY = __cjsModule.EWELINK_PASSWORD_KEY;
export const EWELINK_REGION_KEY = __cjsModule.EWELINK_REGION_KEY;
export const EWELINK_REGIONS = __cjsModule.EWELINK_REGIONS;
export const DEVICE_SERVICE_ID = __cjsModule.DEVICE_SERVICE_ID;
export const DEVICE_EXTERNAL_ID_BASE = __cjsModule.DEVICE_EXTERNAL_ID_BASE;
export const DEVICE_IP_ADDRESS = __cjsModule.DEVICE_IP_ADDRESS;
export const DEVICE_FIRMWARE = __cjsModule.DEVICE_FIRMWARE;
export const DEVICE_ONLINE = __cjsModule.DEVICE_ONLINE;
